"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runJsonataWorker = runJsonataWorker;
exports.runFastJsonataWorker = runFastJsonataWorker;
exports.runJsonata = runJsonata;
const ono_1 = __importDefault(require("@jsdevtools/ono"));
const threads_1 = require("threads");
const error_1 = require("./error");
const evaluate_1 = require("./evaluate");
const promiseWithTimeout_1 = __importStar(require("./promiseWithTimeout"));
__exportStar(require("./bindings/documentation"), exports);
__exportStar(require("./error"), exports);
__exportStar(require("./functions/documentation"), exports);
__exportStar(require("./stediJsonata"), exports);
__exportStar(require("./types"), exports);
/**
 * Run JSONata expression inside Worker thread.
 */
function runJsonataWorker(_a) {
    return __awaiter(this, arguments, void 0, function* ({ bindings, input, mapping, targetExample, timeout, type, }) {
        let thread;
        try {
            const jsonataWorkerStartMs = performance.now();
            const worker = new threads_1.Worker("./jsonataWorker", {
                env: Object.assign({}, process.env),
            });
            thread = yield (0, threads_1.spawn)(worker);
            const mappingResult = yield (0, promiseWithTimeout_1.default)(thread.evaluate({
                mapping,
                type,
                targetExample,
                input,
                bindings,
            }), timeout);
            const jsonataWorkerEndMs = performance.now();
            const workerProcessTimeMs = jsonataWorkerEndMs - jsonataWorkerStartMs;
            return Object.assign(Object.assign({}, mappingResult), { workerProcessTimeMs });
        }
        catch (error) {
            const errorToThrow = getJSONataError(error);
            throw errorToThrow;
        }
        finally {
            if (thread) {
                yield threads_1.Thread.terminate(thread);
            }
        }
    });
}
/**
 * Run JSONata expression inside Worker thread.
 */
function runFastJsonataWorker(_a) {
    return __awaiter(this, arguments, void 0, function* ({ bindings, input, mapping, targetExample, timeout, type, }) {
        let thread;
        try {
            const jsonataWorkerStartMs = performance.now();
            const worker = new threads_1.Worker("./jsonataWorker", {
                env: Object.assign({}, process.env),
            });
            thread = yield (0, threads_1.spawn)(worker);
            const mappingResult = yield (0, promiseWithTimeout_1.default)(thread.evaluateFast({
                mapping,
                type,
                targetExample,
                input,
                bindings,
            }), timeout);
            const jsonataWorkerEndMs = performance.now();
            const workerProcessTimeMs = jsonataWorkerEndMs - jsonataWorkerStartMs;
            return Object.assign(Object.assign({}, mappingResult), { workerProcessTimeMs });
        }
        catch (error) {
            const errorToThrow = getJSONataError(error);
            throw errorToThrow;
        }
        finally {
            if (thread) {
                yield threads_1.Thread.terminate(thread);
            }
        }
    });
}
/**
 * Run JSONata expression.
 */
function runJsonata({ bindings, input, mapping, targetExample, type, }) {
    try {
        const mappingResult = (0, evaluate_1.evaluateSync)({
            mapping,
            type,
            targetExample,
            input,
            bindings,
        });
        return mappingResult;
    }
    catch (error) {
        const errorToThrow = getJSONataError(error);
        throw errorToThrow;
    }
}
function getJSONataError(error) {
    if (error instanceof promiseWithTimeout_1.TimeoutError) {
        return new error_1.MappingTimeoutError(error.timeout);
    }
    // Errors coming from the worker thread might not be inheriting from the Error class.
    // See jsonataWorker.ts for more details.
    if ((0, error_1.isJsonataEvaluationError)(error)) {
        const { code, message, position, token } = error;
        return new error_1.MappingEvaluationError({
            code,
            message,
            name: "MappingEvaluationError",
            token,
            position,
        });
    }
    if ((0, error_1.isJsonataRuntimeError)(error)) {
        const { code, message, position } = error;
        return new error_1.MappingRuntimeError({
            code,
            message,
            name: "MappingRuntimeError",
            position,
        });
    }
    return (0, ono_1.default)(error, "Mapping failed");
}
